var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tost-container"},[_c('div',{staticClass:"tost-warapper"},[_c('p',{staticClass:"tost-content"},[_vm._v(_vm._s(_vm.tostContent))])])])}
var staticRenderFns = []

export { render, staticRenderFns }